const pixKeyQueryMode = {
  FULL: 'FULL',
  OBFUSCATED_DOCUMENT: 'OBFUSCATED_DOCUMENT'
};

module.exports = pixKeyQueryMode;
